import React, { useContext } from 'react';
import { Upload, Modal, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { AuthContext } from 'shared/context/auth-context';
import getBaseUrl from 'shared/utils/getBaseUrl';
import useHandleUnauthorized from 'shared/hooks/unauthorized-hook';

const UploadModal = ({ action, onChange, children, ...props }) => {
  const { token } = useContext(AuthContext);
  const handleUnauthorized = useHandleUnauthorized();

  const handleChange = info => {
    if (info.file.status === 'error' && info.file.error?.status === 401) {
      handleUnauthorized();
      return;
    }
    onChange(info);
  };

  const defaultProps = {
    name: 'file',
    headers: {
      Authorization: `Bearer ${token}`
    },
    multiple: false,
    accept: '.xlsx',
    showUploadList: {
      showRemoveIcon: false,
      showPreviewIcon: false
    },
    action: `${getBaseUrl()}${action}`,
    onChange: handleChange,
    beforeUpload: async () => {
      const resultOfModal = await new Promise((resolve, reject) => {
        Modal.confirm({
          title: 'Ειδοποίηση Εισαγωγής αρχείου!',
          content: 'Επιθυμείτε να γίνει εισαγωγή αρχείου;',
          okText: 'Ναι',
          cancelText: 'Οχι',
          onOk: async () => resolve(),
          onCancel: async () => reject()
        });
      })
        .then(() => true)
        .catch(() => Upload.LIST_IGNORE);
      return resultOfModal;
    },
    disabled: props.disabled,
    ...props
  };

  return (
    <Upload {...defaultProps}>
      {children || (
        <Button
          icon={<UploadOutlined />}
          style={{ backgroundColor: '#f0f0f0' }}
          htmlType="submit"
        >
          Upload File
        </Button>
      )}
    </Upload>
  );
};

export default UploadModal;
